export const templatesList = [
  "default",
  "pro",
  // "compact",
  "rhyhorn",
  "azurill",
  "bronzor",
  "chikorita",
  "ditto",
  "gengar",
  "glalie",
  "kakuna",
  "leafish",
  "nosepass",
  "onyx",
  "pikachu",
] as const;

export type Template = (typeof templatesList)[number];
